import { useState } from "react";
import { IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../redux-store";
import { refreshClients } from "../../ducks/data/clients";
import ClientSelector from "./ClientSelector";

type ClientSelectorWithRefreshProps = {
  selectedClientId: string | null;
  onClientChange: (clientId: string | null) => void;
};

const RefreshClientsButton = () => {
  const { t } = useTranslation("translation");
  const dispatch = useAppDispatch();
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refresh = async () => {
    try {
      setIsRefreshing(true);
      await dispatch(refreshClients()).unwrap();
    } catch {
      // Already reported and shown by the thunk.
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <IconButton
      aria-label={t("refreshClientsLabel")}
      onClick={refresh}
      disabled={isRefreshing}
    >
      <CachedIcon
        sx={
          isRefreshing
            ? {
                animation: "spin 2s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(-360deg)" },
                },
              }
            : null
        }
      />
    </IconButton>
  );
};

const ClientSelectorWithRefresh = (props: ClientSelectorWithRefreshProps) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr auto",
        alignItems: "center",
      }}
    >
      <ClientSelector {...props} />
      <RefreshClientsButton />
    </div>
  );
};

export default ClientSelectorWithRefresh;
